import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import AboutPage from './pages/AboutPage';
import ShopPage from './pages/ShopPage';
import Login from './pages/Login';
import RegisterPage from './pages/RegisterPage';
import MagicLinkVerify from './pages/MagicLinkVerify';
import SetPassword from './pages/SetPassword';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import DeviceRegister from './pages/DeviceRegister';
import Dashboard from './pages/Dashboard';
import DeviceDashboard from './pages/DeviceDashboard';
import DeviceSetup from './pages/DeviceSetup';
import SettingsPage from './pages/SettingsPage';
import { ThemeProvider } from './context/ThemeContext';
import { ToastProvider } from './context/ToastContext';
import AppShell from './components/layout/AppShell';
import './styles/custom.scss';
import './styles/fonts.css';
import './App.css';
import './styles/app-theme.css';
import './styles/marketing-theme.css';
import './styles/auth.css';

function App() {
  return (
      <Router>
        <ThemeProvider>
        <AuthProvider>
        <ToastProvider>
          <Routes>
            {/* Landing Page and About Page as top-level routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/auth/magic-link" element={<MagicLinkVerify />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/app">
              <Route index element={<Login />} />
              <Route element={<AppShell />}>
                <Route path="dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
                <Route path="devices/register" element={<ProtectedRoute><DeviceRegister /></ProtectedRoute>} />
                <Route path="device/:deviceId" element={<ProtectedRoute><DeviceDashboard /></ProtectedRoute>} />
                <Route path="devices/edit/:deviceId" element={<ProtectedRoute><DeviceSetup /></ProtectedRoute>} />
              </Route>
            </Route>
          </Routes>
        </ToastProvider>
        </AuthProvider>
        </ThemeProvider>
      </Router>
  );
}

export default App;
